import { useState } from "react";
import { API_BASE_URL } from "../../../config/apiConfig";
import { useSnackbar } from "../../snackbar/context/SnackbarContext";
import { SSOButton } from "./SSOButton";
import { AUTH_PROVIDER, storeAuthSession } from "../../auth/session";
import axios from "axios";
import "./LoginForm.css";

export const LoginForm = ({ setIsLoggedIn }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const { showSnackbarMessage, showSnackbarError } = useSnackbar();

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    try {
      await authorizeUserWithPkce();
      await generateTokens();

      setIsLoggedIn(true);
      showSnackbarMessage("success", "Login effettuato correttamente!");
    } catch (err) {
      showSnackbarError(err.response);
    }

    setLoading(false);
    setEmail("");
    setPassword("");
  };

  const authorizeUserWithPkce = async () => {
    const { codeVerifier, codeChallenge } = await generatePkce();
    const state = generateState();

    sessionStorage.setItem("pkce_code_verifier", codeVerifier);

    const payload = {
      username: email,
      password,
      code_challenge: codeChallenge,
      code_challenge_method: "S256",
      client_id: "soti-smart-caring-client",
      scope: "read write",
      state,
    };

    const response = await axios.post(
      `${API_BASE_URL}/oauth/authorize`,
      payload,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

    const responseState = response.data.state;
    const responseCode = response.data.code;

    if (responseState !== state) {
      showSnackbarMessage("State mismatch! Possibile attacco CSRF!");
      return;
    }

    sessionStorage.setItem("code_verifier", responseCode);

    console.log("✅ State validato correttamente");
  };

  const generateTokens = async () => {
    const codeVerifier = sessionStorage.getItem("code_verifier");
    const pkceCodeVerifier = sessionStorage.getItem("pkce_code_verifier");

    const payload = {
      code: codeVerifier,
      code_verifier: pkceCodeVerifier,
      client_id: "soti-smart-caring-client",
      grant_type: "authorization_code",
    };

    const response = await axios.post(`${API_BASE_URL}/oauth/token`, payload, {
      headers: { "Content-Type": "application/json" },
    });

    const { access_token, refresh_token } = response.data;

    console.log("✅ Token generati con successo");

    storeAuthSession({
      accessToken: access_token,
      refreshToken: refresh_token,
      provider: AUTH_PROVIDER.CUSTOM_OAUTH2,
    });
  };

  const generatePkce = async () => {
    const randomBytes = new Uint8Array(32);
    window.crypto.getRandomValues(randomBytes);

    const codeVerifier = base64UrlEncode(randomBytes);

    const encoder = new TextEncoder();
    const data = encoder.encode(codeVerifier);
    const hashBuffer = await window.crypto.subtle.digest("SHA-256", data);

    const codeChallenge = base64UrlEncode(new Uint8Array(hashBuffer));

    console.log("✅ PKCE generato:");

    return { codeVerifier, codeChallenge };
  };

  const generateState = () => {
    const bytes = crypto.getRandomValues(new Uint8Array(32));
    return base64UrlEncode(bytes);
  };

  const base64UrlEncode = (array) => {
    const base64 = btoa(String.fromCharCode.apply(null, array));
    return base64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
  };

  return (
    <form className="login-form-container" onSubmit={handleSubmit}>
      <h1 className="login-form-title">AI Station Support</h1>

      <div className="login-form-field">
        <label className="login-form-label">Email</label>
        <input
          className="login-form-input"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
      </div>

      <div className="login-form-field">
        <label className="login-form-label">Password</label>
        <input
          className="login-form-input"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
      </div>

      <button type="submit" className="login-form-button">
        {!loading && "Log In"}

        {loading && (
          <img
            className="login-form-spinner"
            src={`${process.env.PUBLIC_URL}/Trenitalia_logo_RDT.svg.png`}
            alt="spinner"
          />
        )}
      </button>
      {/* NUOVO: Divisore "oppure" */}
      <div className="login-form-divider">
        <span>oppure</span>
      </div>

      {/* NUOVO: Pulsante SSO */}
      <SSOButton />
    </form>
  );
};
